import React, { Component } from 'react';
import KenstanFormStore from '../stores/KenstanFormStore';
import * as KenstanFormAction from '../actions/KenstanFormAction';
import * as ItemDetailNewAction from '../actions/ItemDetailNewAction';
import * as SearchResultsAction from '../actions/SearchResultsAction';
import ItemDetailNewStore from '../stores/ItemDetailNewStore';
import SearchResultsStore from '../stores/SearchResultsStore';
import * as NonCatalogAction from '../actions/NonCatalogAction';
import NonCatalogStore from '../stores/NonCatalogStore';
import * as $ from 'jquery';
import * as CookieService from '../CookieService';
import SDIConstants from '../SDIConstants';
import Select from 'react-select';
import { withTranslation, Trans } from 'react-i18next'
import { pdf } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import swal from 'sweetalert';
import { MapInteractionCSS } from 'react-map-interaction';
import PDFcomponent from './PDFConvert'
import KenstanPDFComponent from './KenstanPDFComponent'
import {
    Document,
    Page,
    Text,
    Image,
    View,
    StyleSheet,
} from '@react-pdf/renderer';
import { Dropdown } from 'react-multi-select-component';
import { style } from '@material-ui/system';


class KestanFormComponent extends Component {
    constructor(props) {
        super(props);

        //const IdsArray = [];
        this.state = {
            pageloaddata: [],
            form: "",
            storenumdisabled: localStorage.getItem("StoreValue") != null ? true : false,
            storenum: localStorage.getItem("StoreValue") != null ? localStorage.getItem("StoreValue").substring(1, localStorage.getItem("StoreValue").length - 1) : "W",
            deptdd: [],
            dept: {},
            colordd: [],
            color: {},
            locktypedd: [],
            locktype: {},
            qty: this.props.location.state.qty,
            keynum: "W",
            lockstyledd: [],
            lockstyle: {},
            attachmentPathArr: [],
            changeorkey: ""



        }
    }

    componentDidMount() {
        console.log('storevalue1', localStorage.getItem("StoreValue"));
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        console.log('qtykenstan', this.props.location.state.quantity)
        console.log('qtykenstan1', CookieService.getLocalStorageValues("QTY_KENSTAN"));
        this.KenstanPageLoad();
        KenstanFormStore.on('PageLoad', this.KestanPageLoadResponse);
        ItemDetailNewStore.on("addToCart", this.AddToCartResponse);
        NonCatalogStore.on('FormsattachmentResponse', this.loadAttachments);
        SearchResultsStore.on("Status", this.AddtocartSuccess);

    }

    componentWillUnmount() {
        KenstanFormStore.removeListener('PageLoad', this.KestanPageLoadResponse);
        ItemDetailNewStore.removeListener("addToCart", this.AddToCartResponse);
        SearchResultsStore.removeListener("addToCart", this.AddtocartSuccess);
        NonCatalogStore.removeListener('FormsattachmentResponse', this.loadAttachments);

    }
    KenstanPageLoad = () => {
        /*[05/02/22, A1QA-172], Priyanka D */
        let CartStorage = JSON.parse(localStorage.getItem("CartStorage"));
        let KenstanItem = "";
        let ItemID = ""
        CartStorage.forEach((val) => {
            if (val.FilePath != null) {
                if (val.FilePath[0] != null) {
                    if (val.FilePath[0].includes('kenstan')) {
                        KenstanItem = KenstanItem.concat(val.Itemid);
                    }
                }
            }
        });
        if (this.props.location.state.pagename == "SearchResult") {
            ItemID = this.props.location.state.item.NonItemDetails[0].ItemId
        } else {
            ItemID = this.props.location.state.item.NonItemDetails[0].ItemId
        }
        if ((CookieService.getLocalStorageValues("KenstanList").indexOf(ItemID) > -1)) {
            window.history.go(-1)
        }
        else {
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            let BO = {
                Supplier_ID: "W000000088",
                Form_Name: ["form_kenstan", "form_kenstan_lock"],
                Label_Name: ["Department", "Key Band Color", "Lock Code", "Lock Types"]
            }
            KenstanFormAction.KestanFormPageLoad(BO);
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
        }
    }


    KestanPageLoadResponse = () => {

        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let PageLoadResponse = JSON.parse(KenstanFormStore.PageLoadData);
        console.log("PageLoadResponse", PageLoadResponse);
        console.log('this.props.location.state.form.', this.props.location.state.form);
        let deptDD = [];
        let colorDD = [];
        let locktypeDD = [];
        let lockstyleDD = [];
        PageLoadResponse.map((val, index) => {
            if (val.LABEL_NAME == 'Department') {
                let obj = { label: val.DD_VALUES, value: val.DD_VALUES };
                deptDD.push(obj);
            } if (val.LABEL_NAME == 'Key Band Color') {
                let obj = { label: val.DD_VALUES, value: val.DD_VALUES };
                colorDD.push(obj);
            } if (val.LABEL_NAME == 'Lock Code') {
                let obj = { label: val.DD_VALUES, value: val.DD_VALUES };
                lockstyleDD.push(obj);
            } if (val.LABEL_NAME == 'Lock Types') {
                let obj = { label: val.DD_VALUES, value: val.DD_VALUES };
                locktypeDD.push(obj);
            }
        });
        this.setState({ pageloaddata: PageLoadResponse, deptdd: deptDD, colordd: colorDD, lockstyledd: lockstyleDD, locktypedd: locktypeDD, form: this.props.location.state.form })
    }
    AddToCart() {
        
        console.log('pagename', this.props.location.state.pagename);
        let quantity = this.props.location.state.qty;
        let quantityValid = quantity % 1;
        if (this.props.location.state.pagename == 'ItemDetail') {
            this.props.location.state.item.NonItemDetails[0].filePath = this.state.attachmentPathArr[0].FilePath;
            
            SearchResultsAction.AddCart(this.props.location.state.item)

        }
        else if (this.props.location.state.pagename == 'SearchResult') {
            this.props.location.state.item.NonItemDetails[0].filePath = this.state.attachmentPathArr[0].FilePath;
            
            SearchResultsAction.AddCart(this.props.location.state.item)

        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please complete the form"
            });
            //alert("Please complete the form");
        }
    }

    AddToCartResponse = () => {
        let AddCartResponse = JSON.parse(ItemDetailNewStore.addToCartList);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let SuccessFlag = AddCartResponse.SuccessFLag;
        let Update_Session = AddCartResponse._FlagDt;
        if (SuccessFlag[0].Status == "true" || SuccessFlag[0].Status == "True") {
            if (Update_Session[0].dtCM != [] && Update_Session[0].dtCM != "") {
                CookieService.updateLocalStorageValues("Session_dtCM", Update_Session[0].dtCM);
            }
            if (Update_Session[0].Session_gotStock != null && Update_Session[0].Session_gotStock != "") {
                CookieService.updateLocalStorageValues("Session_gotStock", Update_Session[0].Session_gotStock);
            }
            if (Update_Session[0].Session_gotNSTK != null && Update_Session[0].Session_gotNSTK != "") {
                CookieService.updateLocalStorageValues("Session_gotNSTK", Update_Session[0].Session_gotNSTK);
            }
            if (Update_Session[0].Session_CARTFAIL != null && Update_Session[0].Session_CARTFAIL != "") {
                CookieService.updateLocalStorageValues("Session_CARTFAIL", Update_Session[0].Session_CARTFAIL);
            }
            this.props.history.push({
                pathname: "/shoppingcart",
            });
        }
        else {
            if (Update_Session[0].Session_CARTFAIL != null && Update_Session[0].Session_CARTFAIL != "") {
                CookieService.updateLocalStorageValues("Session_CARTFAIL", Update_Session[0].Session_CARTFAIL);
            }
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Techincal Issue Contact SDI Customer Care"
            });
            // alert("Techincal Issue Contact SDI Customer Care");
        }
    }
    handleAttachment = (b) => {
        if (this.props.location.state.form.indexOf('KEY') > -1) {
            if (this.state.color != {} && this.state.dept != {} && this.state.changeorkey != "" && this.state.storenum.length > 1 && this.state.keynum.length > 1) {
                var b = new File([b], 'kenstan.pdf');
                let files = [];
                files.push(b);
                CookieService.updateLocalStorageValues("IsKenstan", true);
                CookieService.updateLocalStorageValues("IsKenstanKey", true);
                if (files.length > 0) {

                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Item Successfully Added To Cart"
                    });
                    // alert("Item Successfully Added To Cart")
                    NonCatalogAction.FormsaddAttachment(files);
                }
            }

        } else {
            if (this.state.color != {} && this.state.dept != {} && this.state.storenum.length > 1 && this.state.keynum.length > 1 && this.state.lockstyle != {} && this.state.locktype != {}) {
                var b = new File([b], 'kenstan.pdf');
                let files = [];
                files.push(b);

                CookieService.updateLocalStorageValues("IsKenstan", true);
                if (files.length > 0) {

                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Item Successfully Added To Cart"
                    });
                    //  alert("Item Successfully Added To Cart")
                    NonCatalogAction.FormsaddAttachment(files);
                }
            }
        }

    }

    loadAttachments = () => {
        
        let isValid = NonCatalogStore.attachmentResponse.indexOf("You have exceeded the length of total file names") >= 0 ? false : true;
        if (isValid) {
            let attachmentResponse = JSON.parse(NonCatalogStore.attachmentResponse);
            console.log("attachmentResponse", attachmentResponse);
            let tempAttachments = this.state.attachmentPathArr;
            tempAttachments = tempAttachments.concat(attachmentResponse);
            this.setState({ attachmentPathArr: tempAttachments });
            this.AddToCart();

        } else {
            this.setState({
                attachmentErrormsg: "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names."
            });
        }
    };

    AddtocartSuccess = () => {
        //$(`#${SDIConstants.SDILoader}`).addClass('hide');
        
        let Status = JSON.parse(SearchResultsStore.SuccessStatus);

        let itemstatus = Status._FlagDt
        let iteminsertstatus = Status.SuccessFLag
        let PageLSearchResults = this.state.PageLoadSearchResults;
        let FilterdValue = this.state.FilteredSearchResults;
        if (itemstatus.length > 0) {
            if (itemstatus[0].is_Success == "True" || itemstatus[0].is_Success == "true") {

                let itemidnotinserted = ""
                if (iteminsertstatus != null && iteminsertstatus != undefined && iteminsertstatus != "") {
                    iteminsertstatus.map((val, index) => {
                        if (val.Status != "true") {
                            if (itemidnotinserted != "") {
                                itemidnotinserted = itemidnotinserted + "," + val.ItemId
                            }
                            else {
                                itemidnotinserted = itemidnotinserted + val.ItemId
                            }
                        }
                    });
                }
                if (itemidnotinserted != null && itemidnotinserted != undefined && itemidnotinserted != "") {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Item " + itemidnotinserted + " is not added to cart due to technical issue. Contact SDI customer care."

                    });
                    //  alert("Item " + itemidnotinserted + " is not added to cart due to technical issue. Contact SDI customer care.")
                }

                //window.location.reload();
                //$(`#${SDIConstants.SDILoader}`).removeClass('hide');

                this.props.history.push({
                    //pathname: "/shoppingcart",
                    pathname: `\shoppingcart`,
                    search: `?SearchKey=${this.props.location.state.searchKey}`
                });

            }
            else {

                let itemidnotinserted = ""
                let validate = false
                if (iteminsertstatus != null && iteminsertstatus != undefined && iteminsertstatus != "") {
                    iteminsertstatus.map((val, index) => {
                        if (val.Status != "true") {
                            if (itemidnotinserted != "") {
                                itemidnotinserted = itemidnotinserted + "," + val.ItemId
                            }
                            else {
                                itemidnotinserted = itemidnotinserted + val.ItemId
                            }
                        }
                        else if (validate != true && val.Status == "true") {
                            validate = true
                        }
                    });
                }
                if (itemidnotinserted != null && itemidnotinserted != undefined && itemidnotinserted != "") {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Item " + itemidnotinserted + " is not added to cart due to technical issue. Contact SDI customer care."

                    });
                    //  alert("Item " + itemidnotinserted + " is not added to cart due to technical issue. Contact SDI customer care.")
                }
                if (validate == true) {

                    //window.location.reload();




                    this.props.history.push({
                        //pathname: "/shoppingcart",
                        pathname: `\shoppingcart`,
                        search: `?SearchKey=${this.props.location.state.searchKey}`
                    });


                }
                else if (itemidnotinserted == null || itemidnotinserted == undefined || itemidnotinserted == "") {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Techincal Issue Contact SDI Customer Care"

                    });
                    //  alert("Techincal Issue Contact SDI Customer Care")
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                }
                else {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                }
            }
        }

    }


    handleChangeDept = (values) => {
        this.setState(
            { dept: values })
    }
    handleChangeColor = (values) => {
        this.setState(
            { color: values })
    }
    handleChangeLockStyle = (values) => {
        this.setState(
            { lockstyle: values })
    }
    handleChangeLockType = (values) => {
        this.setState(
            { locktype: values })
    }

    handleChangeKeyNum = (values) => {

        if (isNaN(Number.parseInt(values.target.value.substring(values.target.value.length - 1, values.target.value.length)))) {
            if (values.target.value.length == 1) {
                this.setState(
                    { keynum: 'W' })
            } else {
                this.setState(
                    { keynum: 'W' + values.target.value.substring(1, values.target.value.length - 1) })
            }
        } else {
            this.setState(
                { keynum: 'W' + values.target.value.substring(1, values.target.value.length) })
        }

    }
    handleChangeStoreNum = (values) => {
        if (isNaN(Number.parseInt(values.target.value.substring(values.target.value.length - 1, values.target.value.length)))) {
            if (values.target.value.length == 1) {
                this.setState(
                    { storenum: 'W' })
            } else {
                this.setState(
                    { storenum: 'W' + values.target.value.substring(1, values.target.value.length - 1) })
            }
        } else {
            this.setState(
                { storenum: 'W' + values.target.value.substring(1, values.target.value.length) })
        }
    }
    handleChangeQty = (values) => {
        if (isNaN(Number.parseInt(values.target.value.substring(values.target.value.length - 1, values.target.value.length)))) {

        } else {
            this.setState(
                { qty: values.target.value })
        }
    }
    handleChangeValue = (values) => {
        console.log("havnel", values.target.value);
        this.setState(
            { changeorkey: values.target.value })

    }






    render() {
        return (
            //<div className="container-fluid content-section">
            <div className="container-fluid content-margin cctop">
                <div className="row">
                    <div className="col-md-12 page-heading my-3">
                        {this.props.location.state.form.indexOf('KEY') > -1 ?
                            <h5 className="page-title"><Trans>Kenstan Key Form</Trans></h5> : <h5 className="page-title"><Trans>Kenstan Lock Form</Trans></h5>}
                    </div>

                    {this.props.location.state.form.indexOf('KEY') == -1 ?
                        <div className="col-md-5 page-heading my-3">

                            <div className="col-md-12 mb-4">

                                <label className="float-left col-md-4 form-label catalog-label" >Store Number</label>
                                <input type="text" className="form-control col-md-6 " maxLength="5" name="Quantityvalue" id="Storenum"
                                    value={this.state.storenum} onChange={e => this.handleChangeStoreNum(e)}
                                    disabled={this.state.storenumdisabled}
                                />
                            </div>

                            <div className="col-md-12 mb-4">
                                <label className="float-left col-md-4 form-label catalog-label" >Department</label>
                                <div className="col-md-10 p-0">
                                    <Select
                                        id="OLDept"
                                        className="DropDown-Font-Size"
                                        value={this.state.dept}
                                        onChange={(e) => this.handleChangeDept(e)}
                                        options={this.state.deptdd}
                                    />
                                </div></div>
                            <div className="col-md-12 mb-4">
                                <label className="float-left col-md-4 form-label catalog-label" >Key Band Color</label>
                                <div className="col-md-10 p-0">
                                    <Select
                                        id="OLColor"
                                        className="DropDown-Font-Size"
                                        value={this.state.color}
                                        onChange={(e) => this.handleChangeColor(e)}
                                        options={this.state.colordd}
                                    />
                                </div></div>
                            <div className="col-md-12 mb-4">
                                <label className="float-left col-md-4 form-label catalog-label">Lock Types</label>
                                <div className="col-md-10 p-0">
                                    <Select
                                        id="OLlocktype"
                                        className="DropDown-Font-Size"
                                        value={this.state.locktype}
                                        onChange={(e) => this.handleChangeLockType(e)}
                                        options={this.state.locktypedd}
                                    />
                                </div></div>
                            <div className="col-md-12 mb-4">
                                <label className="float-left col-md-4 form-label catalog-label" >Lock Quantity Needed</label>
                                <label className="col-md-5 mt-1">{this.state.qty}</label>
                            </div>
                            <div className="col-md-12 mb-4">
                                <label className="float-left col-md-4 form-label catalog-label" >Key Number</label>

                                <input type="text" className="form-control col-md-6 " maxlength="6" value={this.state.keynum} onChange={e => this.handleChangeKeyNum(e)} />
                            </div>

                            <div className="col-md-12 mb-4">
                                <label className="float-left col-md-4 form-label catalog-label" >Lock Style</label>
                                <div className="col-md-10 p-0">
                                    <Select
                                        id="OLlockstyle"
                                        className="DropDown-Font-Size"
                                        value={this.state.lockstyle}
                                        onChange={(e) => this.handleChangeLockStyle(e)}
                                        options={this.state.lockstyledd}
                                    />
                                </div></div>

                            <div className="col-md-12 mb-4">
                                <div className="float-right mobile-catalog-btns" style={{ marginRight: "9.5%" }}>

                                    <button className="btn btn-primary custom-btn-primary primary-btn px-3 ml-3"
                                        onClick={

                                            async () => {
                                                
                                                console.log('color', this.state.color);
                                                if (Object.keys(this.state.color).length != 0 && Object.keys(this.state.dept).length != 0 && this.state.storenum.length > 1 && this.state.keynum.length > 1 && Object.keys(this.state.locktype).length != 0 && Object.keys(this.state.lockstyle).length != 0) {
                                                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                                                    const doc = <KenstanPDFComponent item={this.props.location.state.item} form={this.props.location.state.form} keynum={this.state.keynum}
                                                        qty={this.state.qty} dept={this.state.dept.label} color={this.state.color.label} dept={this.state.dept.label} storenum={this.state.storenum}
                                                        locktype={this.state.locktype.label} lockstyle={this.state.lockstyle.label} WO={this.props.location.state.WO} keyorchange=""
                                                        key="key1" />;
                                                    const asPdf = pdf([]);
                                                    asPdf.updateContainer(doc);
                                                    const blob = await asPdf.toBlob();
                                                    saveAs(blob, 'kenstanlock.pdf');
                                                    this.handleAttachment(blob);
                                                } else {
                                                    swal({
                                                        allowOutsideClick: false,
                                                        closeOnClickOutside: false,
                                                        text: "Please complete the form"

                                                    });
                                                    //  alert("Please complete the form")
                                                }
                                            }
                                        }
                                    >Add To Cart</button>
                                </div>
                            </div>
                        </div> : <div className="col-md-5 page-heading my-3">
                            <div className="col-md-12 mb-4">

                                <label className="float-left col-md-4 form-label catalog-label" >Store Number</label>
                                <input type="text" className="form-control col-md-6 " maxLength="5" name="Quantityvalue" id="Storenum"
                                    value={this.state.storenum} onChange={e => this.handleChangeStoreNum(e)}
                                    disabled={this.state.storenumdisabled}
                                />
                            </div>

                            <div className="col-md-12 mb-4">
                                <label className="float-left col-md-4 form-label catalog-label">Department</label>
                                <div className="col-md-10 p-0">
                                    <Select
                                        id="OLDept"
                                        className="DropDown-Font-Size"
                                        value={this.state.dept}
                                        onChange={(e) => this.handleChangeDept(e)}
                                        options={this.state.deptdd}
                                    />
                                </div></div>
                            <div className="col-md-12 mb-4">
                                <label className="float-left col-md-4 form-label catalog-label">Key Band Color</label>
                                <div className="col-md-10 p-0">
                                    <Select
                                        id="OLColor"
                                        className="DropDown-Font-Size"
                                        value={this.state.color}
                                        onChange={(e) => this.handleChangeColor(e)}
                                        options={this.state.colordd}
                                    />
                                </div></div>
                            <div className="col-md-12 mb-4" >
                                <label className="col-md-4 form-label catalog-label mb-4">Key or Change Tool?</label>
                                <label onChange={(e) => this.handleChangeValue(e)} className="col-md-6 form-label mt-2">
                                    <input type="radio" id="choice1" value="Key" checked={this.state.changeorkey === "Key"} className="mr-1"
                                    /> Key
                                    <span className="mr-3"></span>
                                    < input type="radio" id="choice2"
                                        value="Change Tool" checked={this.state.changeorkey === "Change Tool"} className="mr-1" />Change Tool
                           
                               </label>
                            </div>
                            <div className="col-md-12 mb-4">
                                <label className="float-left col-md-4 form-label catalog-label" >Key Number</label>

                                <input type="text" className="form-control col-md-6 " maxlength="6" name="Quantityvalue" value={this.state.keynum} onChange={e => this.handleChangeKeyNum(e)} />
                            </div>
                            <div className="col-md-12 mb-4">
                                <label className="float-left col-md-4 form-label catalog-label" >Key Quantity Needed</label>
                                <label className="col-md-4 mt-1">{this.state.qty}</label>
                            </div>

                            <div className="col-md-12 mb-4">
                                <div className="float-right mobile-catalog-btns" style={{ marginRight: "9.5%" }}>

                                    <button className="btn btn-primary custom-btn-primary primary-btn px-3 ml-3"
                                        onClick={
                                            async () => {
                                                if (Object.keys(this.state.color).length != 0 && Object.keys(this.state.dept).length != 0 && this.state.changeorkey != "" && this.state.storenum.length > 1 && this.state.keynum.length > 1) {
                                                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                                                    const doc = <KenstanPDFComponent item={this.props.location.state.item} form={this.props.location.state.form}
                                                        qty={this.state.qty} dept={this.state.dept.label} color={this.state.color.label} storenum={this.state.storenum}
                                                        keynum={this.state.keynum} locktype={this.state.locktype.label} lockstyle={this.state.lockstyle.label} keyorchange={this.state.changeorkey}
                                                        WO={this.props.location.state.WO}
                                                        key="key2" />;
                                                    const asPdf = pdf([]);
                                                    asPdf.updateContainer(doc);
                                                    const blob = await asPdf.toBlob();
                                                    saveAs(blob, 'kenstankey.pdf');
                                                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                                                    CookieService.updateLocalStorageValues("IsKenstanKey", true);
                                                    this.handleAttachment(blob);
                                                } else {
                                                    swal({
                                                        allowOutsideClick: false,
                                                        closeOnClickOutside: false,
                                                        text: "Please complete the form"

                                                    });
                                                    //   alert("Please complete the form")
                                                }
                                            }
                                        }
                                    >Add To Cart</button>
                                </div>
                            </div>



                        </div>}
                    {this.props.location.state.form.indexOf('KEY') == -1 ?
                        <div className="col-md-6 page-heading my-3">

                            <div className="col-md-12 mb-4" style={{ 'border': 'gray 1px solid' }}>

                                <MapInteractionCSS minScale={1} maxScale={3.5} translationBounds={{ xMin: -1500, xMax: 60, yMin: -1250, yMax: 60 }} showControls >
                                    <img src="/Images/Kenstan_form.png" style={{ width: "100%", minWidth: "100%" }} />
                                </MapInteractionCSS>
                            </div>
                        </div> : null}

                </div>

            </div>

        );
    };
}
export default withTranslation()(KestanFormComponent);